import { Component, Input } from "@angular/core";
import { Observable } from "rxjs";

@Component({
    selector: 'async-observable',
    template: require('./async-observable.component.html')
})
export class AsyncObservableComponent {
    @Input() observable$: Observable<any>;
    @Input() useLoading: boolean;

    constructor() { }

    ngOnInit(): void {
    }
}
